/* eslint-disable */
import { CommonGet } from '../../../helpers/HttpClient';


export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetDailyPerformOrderDetails
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetDailyPerformOrderDetails(groupID, factoryID, date) {
    const response = await CommonGet('/api/ViewDailyPerformOrderControlller/GetDailyPerformOrderDetails', 'groupID=' + parseInt(groupID)
        + '&factoryID=' + parseInt(factoryID) + '&date=' + date);
    return response.data;
}






